import { Box } from '@wix/design-system'
import React, { ComponentProps, FC } from 'react'

export const Card: FC<ComponentProps<typeof Box>> = props => (
  <Box
    background="#fff"
    borderRadius="6px"
    width="100%"
    boxSizing="border-box"
    padding="18px"
    verticalAlign="middle"
    {...props}
  />
)
